import AuthAPI from "./auth.js";
const Auth = new AuthAPI();

// Public
export function createNotarization(source_value = null) {
	if (source_value) {
		return Auth.POST(`/notarization?notary_source=${source_value}`);
	}
	return Auth.POST(`/notarization`);
}

export function documents(notarizationId) {
	return Auth.GET(`/notarization/${notarizationId}/documents`);
}

export function summary(notarizationId) {
	return Auth.GET(`/notarization/${notarizationId}/summary`);
}

export function latestNotarization(sessionStatusId) {
	return Auth.GET(`/notarization/latest/${sessionStatusId}`);
}
export function resetNotarization(notarizationId) {
	return Auth.POST(`/notarization/${notarizationId}/resetnotarizationstatus`);
}